module.exports = __webpack_public_path__ + "img/ALTAYR.89b731f8.png";